// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".group___NDmlz{display:flex;flex-direction:column;gap:16px}.row___7zmXJ{flex-direction:row}\n", "",{"version":3,"sources":["webpack://./src/components/ButtonGroup/ButtonGroup.css"],"names":[],"mappings":"AAAA,eACI,YAAA,CACA,qBAAA,CACA,QAAA,CAGJ,aACI,kBAAA","sourcesContent":[".group {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.row {\n    flex-direction: row;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"group": "group___NDmlz",
	"row": "row___7zmXJ"
};
export default ___CSS_LOADER_EXPORT___;
